// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__M2cD6","root":"Tabs_root__+yHsM"};